/* Wagbowl — custom.js
   Function-scoped, progressive enhancement only. No dependencies.
   Adds .wb-scrolled to the header once the page is scrolled, so the
   mobile sticky header can show a subtle shadow (styled in custom.css). */
(function () {
  'use strict';

  var header = document.querySelector('.wb-header-section') || document.querySelector('.section-header');
  if (!header) return;

  var ticking = false;
  function update() {
    header.classList.toggle('wb-scrolled', window.scrollY > 4);
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();

/* Wagbowl — WB Hero rolling word.
   No-ops if the hero isn't on the page. Server render already shows word #1,
   so this only enhances. Respects prefers-reduced-motion + document.hidden.
   ONE pass, then it rests (Bible §5: no loops, nothing still moving after load): it lands
   back on word #1 ("your dog"), or on "your <name>" when the quiz stored one. */
(function () {
  'use strict';

  var hero = document.querySelector('.wb-hero');
  if (!hero) return;
  var rolling = hero.querySelector('.wb-hero__rolling');
  if (!rolling) return;

  // Audit A-01 (2026-10-21): words 2..n are shipped in a <template> so the h1 holds one sentence
  // for search engines; move them in here, before the cycle starts.
  var tpl = hero.querySelector('template.wb-hero__words');
  if (tpl && tpl.content) rolling.appendChild(tpl.content.cloneNode(true));

  var words = Array.prototype.slice.call(rolling.querySelectorAll('.wb-hero__word'));

  // Personalization hook: if the quiz has stored a dog name, append
  // "your <name>" as the final word (with its own dot) and stop on it.
  var stopOnLast = false;
  try {
    var dogName = localStorage.getItem('wb_dog_name');
    if (dogName) {
      var extra = document.createElement('span');
      extra.className = 'wb-hero__word';
      extra.textContent = 'your ' + dogName;
      var pd = document.createElement('span');
      pd.className = 'wb-hero__dot';
      pd.setAttribute('aria-hidden', 'true');
      var pc = document.createElement('span');
      pc.className = 'wb-hero__dot-core';
      pd.appendChild(pc);
      extra.appendChild(pd);
      rolling.appendChild(extra);
      words.push(extra);
      stopOnLast = true;
    }
  } catch (e) {}

  if (words.length < 2) return;

  // Reduced motion: leave word #1 static (already .is-active server-side).
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var speed = parseFloat(hero.getAttribute('data-cycle-speed')) || 2.4;
  var intervalMs = Math.max(1500, speed * 1000);
  var i = 0;
  var timer = null;

  function show(next) {
    var out = words[i];
    out.classList.remove('is-active');
    out.classList.add('is-out');
    setTimeout(function () { out.classList.remove('is-out'); }, 450);
    var incoming = words[next];
    incoming.classList.remove('is-out');
    incoming.classList.add('is-active');
    i = next;
    var d = incoming.querySelector('.wb-hero__dot');  // pulse the now-active word's dot
    if (d) {
      d.classList.remove('is-pulse');
      void d.offsetWidth;             // reflow so the pulse restarts each change
      d.classList.add('is-pulse');
    }
  }

  var rested = false;   // set once the single pass has landed back on word #1
  function landed() { return rested || (stopOnLast && i === words.length - 1); }

  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function start() { if (!timer && !landed()) timer = setInterval(tick, intervalMs); }

  function tick() {
    var next = i + 1;
    if (next >= words.length) {
      if (stopOnLast) { stop(); return; }
      show(0); rested = true; stop(); return;   // back to "your dog", and stay there
    }
    show(next);
    if (stopOnLast && next === words.length - 1) stop();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  start();
})();

/* Wagbowl — one raised yellow on screen at a time.
   The homepage hero has its own yellow button; while it is in view, the header's desktop
   pill steps aside (custom.css hides it from first paint via :has(.wb-hero__cta)). Once the
   hero button scrolls away this flags body.wb-hero-cta-past and the pill fades back in.
   No IntersectionObserver: flag it straight away so the pill is never lost. */
(function () {
  'use strict';

  var cta = document.querySelector('.wb-hero__cta');
  if (!cta) return;
  if (!('IntersectionObserver' in window)) { document.body.classList.add('wb-hero-cta-past'); return; }
  new IntersectionObserver(function (entries) {
    document.body.classList.toggle('wb-hero-cta-past', !entries[0].isIntersecting);
  }).observe(cta);
})();

/* Wagbowl — hero-lead transparent header.
   When the hero leads the page, flag the body so custom.css can overlay a
   transparent header, and publish the header height for the overlap offset.
   No-ops on every page without a hero.

   The predicate is INCLUSIVE: any section that declares itself a leading hero by
   emitting [data-wb-bleed] opts in, so a future section joins without touching this
   file again. .wb-hero stays listed because the homepage hero predates the attribute.
   Note this block also PUBLISHES --wb-header-h from the live header height, which the
   negative margin in custom.css consumes — that is why the bleed cannot be done in CSS
   alone with a fallback constant (it would be wrong by header-height minus 64px). */
(function () {
  'use strict';

  var hero = document.querySelector('.wb-hero, [data-wb-bleed]');
  var header = document.querySelector('.wb-header-section') || document.querySelector('.section-header');
  if (!hero || !header) return;

  document.body.classList.add('wb-hero-lead');

  function setHeaderHeight() {
    document.documentElement.style.setProperty('--wb-header-h', header.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });
  window.addEventListener('load', setHeaderHeight);
})();

/* Wagbowl — Trust bar scroll-reveal.
   Fades the cells up in a gentle stagger when the bar enters view.
   No-ops off-page; leaves items visible under reduced-motion or no IO support. */
(function () {
  'use strict';

  var bars = document.querySelectorAll('.wb-trust');
  if (!bars.length) return;

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) {
    return; // items stay visible (server-rendered state)
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wb-trust--in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
  );

  bars.forEach(function (bar) {
    bar.classList.add('wb-trust--reveal'); // arm the hidden state, then observe
    io.observe(bar);
  });
})();

/* Wagbowl — Kibble ↔ Fresh moisture gauge.
   JS flips a state class (.wb-kv--kibble / .wb-kv--fresh) and, in ONE rAF, steps
   BOTH the number text and the --wb-kv-fill custom property together so the paw
   fill and the figure move as one. --wb-kv-fill is the only style property JS writes.
   No-ops off-page. Reduced-motion / no IO: stay FRESH, static, toggles still work. */
(function () {
  'use strict';

  var el = document.querySelector('.wb-kv');
  if (!el) return;

  var numEl = el.querySelector('.wb-kv__num');
  var pills = Array.prototype.slice.call(el.querySelectorAll('[data-wb-state]'));
  var kNum = parseInt(el.getAttribute('data-kibble'), 10) || 0;
  var fNum = parseInt(el.getAttribute('data-fresh'), 10) || 0;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rafId = null;

  function render(v) {
    if (numEl) numEl.textContent = Math.round(v);
    el.style.setProperty('--wb-kv-fill', v); // number + paw fill, one source of truth
  }

  function animateTo(target) {
    if (rafId) window.cancelAnimationFrame(rafId);
    var from = parseFloat(el.style.getPropertyValue('--wb-kv-fill'));
    if (isNaN(from)) from = numEl ? parseInt(numEl.textContent, 10) || 0 : 0;
    if (from === target) { render(target); return; }
    var start = null;
    var duration = 900;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      render(from + (target - from) * eased);
      if (p < 1) rafId = window.requestAnimationFrame(step);
      else render(target);
    }
    rafId = window.requestAnimationFrame(step);
  }

  function setState(state, animate) {
    var kibble = state === 'kibble';
    el.classList.toggle('wb-kv--kibble', kibble);
    el.classList.toggle('wb-kv--fresh', !kibble);
    pills.forEach(function (p) {
      p.setAttribute('aria-pressed', p.getAttribute('data-wb-state') === state ? 'true' : 'false');
    });
    var target = kibble ? kNum : fNum;
    if (animate && !reduce) animateTo(target);
    else render(target);
  }

  pills.forEach(function (p) {
    p.addEventListener('click', function () { setState(p.getAttribute('data-wb-state'), true); });
  });

  // Fallback: no motion / no IO → fresh, static (paw at fresh %), toggles still work.
  if (reduce || !('IntersectionObserver' in window)) {
    setState('fresh', false);
    return;
  }

  // Intro: start kibble (section is off-screen, so no flash), auto-morph once.
  setState('kibble', false);
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();
        window.setTimeout(function () { setState('fresh', true); }, 400);
      });
    },
    { threshold: 0.4 }
  );
  io.observe(el);
})();

/* Wagbowl — Recipe cards mobile deck (progressive enhancement).
   Function-scoped, no deps. Mobile (<750px) only: stacks the cards into a
   swipeable deck (touch swipe + arrow/dot controls). Desktop keeps the CSS grid.
   prefers-reduced-motion / no-JS: this whole block no-ops and the CSS
   single-column stack fallback is what the user sees. Transform + opacity only. */
(function () {
  'use strict';

  var deck = document.querySelector('.wb-rc__grid[data-wb-deck="on"]');   // grid layout (default) never becomes a deck
  if (!deck) return;
  var cards = Array.prototype.slice.call(deck.querySelectorAll('.wb-rc__card'));
  var n = cards.length;
  if (n < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var mq = window.matchMedia('(max-width: 749px)');
  // depth → [translateY(px), scale, opacity]
  var STACK = [[0, 1, 1], [22, 0.94, 1], [40, 0.88, 0.9], [58, 0.82, 0.8]];
  var current = 0;
  var active = false;
  var busy = false;
  var controls = null;
  var dots = [];
  var resizeT = null;

  function stackFor(d) { return STACK[Math.min(d, STACK.length - 1)]; }

  function place(card, d, animate) {
    var s = stackFor(d);
    card.style.transition = animate ? 'transform 350ms ease-out, opacity 350ms ease-out' : 'none';
    card.style.transform = 'translateY(' + s[0] + 'px) scale(' + s[1] + ')';
    card.style.opacity = String(s[2]);
    card.style.zIndex = String(100 - d);
    var front = d === 0;
    card.setAttribute('aria-hidden', front ? 'false' : 'true');
    card.style.pointerEvents = front ? 'auto' : 'none';
    var link = card.querySelector('a');
    if (link) link.tabIndex = front ? 0 : -1;
  }

  function syncDots() {
    dots.forEach(function (dot, idx) {
      var on = idx === current;
      dot.classList.toggle('is-on', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function render(animate) {
    cards.forEach(function (card, idx) { place(card, (idx - current + n) % n, animate); });
    syncDots();
  }

  function measure() {
    var maxH = 0;
    cards.forEach(function (c) {
      c.style.transition = 'none';
      c.style.transform = 'none';
      if (c.offsetHeight > maxH) maxH = c.offsetHeight;
    });
    deck.style.height = (maxH + 64) + 'px'; // room for the deepest peeking card
    render(false);
  }

  function next() {
    if (busy) return;
    busy = true;
    var leaving = cards[current];
    leaving.style.transition = 'transform 350ms ease-out, opacity 350ms ease-out';
    leaving.style.transform = 'translateX(-115%) rotate(-6deg)';
    leaving.style.opacity = '0';
    current = (current + 1) % n;
    cards.forEach(function (card, idx) {
      if (card === leaving) return;
      place(card, (idx - current + n) % n, true);
    });
    syncDots();
    window.setTimeout(function () {
      place(leaving, (cards.indexOf(leaving) - current + n) % n, false); // drop to the back
      busy = false;
    }, 360);
  }

  function prev() {
    if (busy) return;
    current = (current - 1 + n) % n;
    render(true);
  }

  function goTo(i) {
    if (busy || i === current) return;
    current = (i + n) % n;
    render(true);
  }

  function buildControls() {
    controls = document.createElement('div');
    controls.className = 'wb-rc__controls';
    controls.hidden = true;

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'wb-rc__arrow';
    prevBtn.setAttribute('aria-label', 'Previous recipe');
    prevBtn.innerHTML = '‹';
    prevBtn.addEventListener('click', prev);

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'wb-rc__dots';
    for (var k = 0; k < n; k++) {
      (function (idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wb-rc__dot';
        dot.setAttribute('aria-label', 'Show recipe ' + (idx + 1));
        dot.addEventListener('click', function () { goTo(idx); });
        dots.push(dot);
        dotsWrap.appendChild(dot);
      })(k);
    }

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'wb-rc__arrow';
    nextBtn.setAttribute('aria-label', 'Next recipe');
    nextBtn.innerHTML = '›';
    nextBtn.addEventListener('click', next);

    controls.appendChild(prevBtn);
    controls.appendChild(dotsWrap);
    controls.appendChild(nextBtn);
    controls.addEventListener('pointerdown', lockAuto);   // arrows/dots → stop autoplay for good
    deck.parentNode.appendChild(controls);
  }

  function bindDrag() {
    var startX = 0, dx = 0, dragging = false, front = null, moved = false;

    deck.addEventListener('pointerdown', function (e) {
      if (active) lockAuto();   // any touch on the deck stops autoplay for good
      if (!active || busy) return;
      front = cards[current];
      dragging = true;
      moved = false;
      startX = e.clientX;
      dx = 0;
      front.style.transition = 'none';
      try { deck.setPointerCapture(e.pointerId); } catch (err) {}
    });
    deck.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      if (Math.abs(dx) > 6) moved = true;
      front.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx * 0.03) + 'deg)';
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      if (dx < -45) next();
      else if (dx > 45) prev();
      else place(front, 0, true); // snap back
    }
    deck.addEventListener('pointerup', end);
    deck.addEventListener('pointercancel', end);
    // A swipe ends in a click; suppress it so the stretched card-link doesn't navigate.
    deck.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function reset(card) {
    card.style.transition = '';
    card.style.transform = '';
    card.style.opacity = '';
    card.style.zIndex = '';
    card.style.pointerEvents = '';
    card.removeAttribute('aria-hidden');
    var link = card.querySelector('a');
    if (link) link.removeAttribute('tabindex');
  }

  function enable() {
    if (active) return;
    active = true;
    deck.classList.add('is-deck');
    if (controls) controls.hidden = false;
    current = 0;
    measure();
    if (io) io.observe(deck);   // autoplay only while the deck is on-screen
  }

  function disable() {
    if (!active) return;
    active = false;
    deck.classList.remove('is-deck');
    deck.style.height = '';
    if (controls) controls.hidden = true;
    stopAuto();
    if (io) io.unobserve(deck);
    cards.forEach(reset);
  }

  function sync() { if (mq.matches) enable(); else disable(); }

  // ---- Mobile auto-swipe: reuse next() every ~3s, pause off-screen (IntersectionObserver),
  //      and stop PERMANENTLY on any user interaction. Reduced-motion already returned above,
  //      so autoplay never runs there. Desktop never enables the deck, so this is mobile-only. ----
  var AUTO_MS = 3000;
  var autoTimer = null;
  var userLocked = false;   // set once the user takes control — never resumes this session
  var io = null;

  function startAuto() {
    if (autoTimer || userLocked || !active) return;
    autoTimer = window.setInterval(function () { if (!busy) next(); }, AUTO_MS);
  }
  function stopAuto() {
    if (autoTimer) { window.clearInterval(autoTimer); autoTimer = null; }
  }
  function lockAuto() {
    userLocked = true;
    stopAuto();
  }
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) startAuto(); else stopAuto();
      });
    }, { threshold: 0.5 });
  }

  buildControls();
  bindDrag();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
  window.addEventListener('resize', function () {
    if (!active) return;
    clearTimeout(resizeT);
    resizeT = setTimeout(measure, 150);
  }, { passive: true });

  sync();
})();

/* Wagbowl — header bottom-sheet controller (mobile drawer).
   Function-scoped, no deps. Opens/closes the cream sheet with focus-trap, body
   scroll-lock, ESC-to-close and aria-expanded. Reduced-motion: show/hide with no
   slide (CSS drops the transitions; JS skips the close delay). No-ops off-page. */
(function () {
  'use strict';

  var root = document.querySelector('[data-wb-hd]');
  if (!root) return;
  var sheet = root.querySelector('[data-wb-hd-sheet]');
  var openBtn = root.querySelector('[data-wb-hd-open]');
  if (!sheet || !openBtn) return;
  var panel = sheet.querySelector('.wb-hd-sheet__panel');
  if (!panel) return;

  // 15 Oct 2026 (Kevan: "I can't click out of it" + "the page gets completely stuck"). The header has a frosted
  // backdrop-filter and slides away on scroll; both make it the containing block for position:fixed children, so the
  // sheet's scrim only covered the header strip (tapping the page did nothing) and, with the header slid away, the
  // sheet opened off-screen while the body scroll was locked. Moving the sheet to <body> makes fixed mean the screen.
  if (sheet.parentNode !== document.body) document.body.appendChild(sheet);
  openBtn.setAttribute('aria-controls', sheet.id || 'wb-hd-sheet');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var closeT = null;
  var lastFocus = null;

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }

  function lockScroll(on) {
    // custom.css sets `html { scrollbar-gutter: stable }`, so the gutter is always
    // reserved and locking scroll no longer shifts layout — no padding-right needed
    // (adding it now would over-compensate against the reserved gutter).
    document.body.classList.toggle('wb-hd-open', on);
    // the page behind is out of reach for keyboards and screen readers while the sheet is open (aria-modal + inert)
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === sheet || el.tagName === 'SCRIPT') return;
      if (on) { if (!el.hasAttribute('inert')) { el.setAttribute('inert', ''); el.setAttribute('data-wb-hd-inert', ''); } }
      else if (el.hasAttribute('data-wb-hd-inert')) { el.removeAttribute('inert'); el.removeAttribute('data-wb-hd-inert'); }
    });
  }

  function open() {
    if (closeT) { clearTimeout(closeT); closeT = null; }
    lastFocus = document.activeElement;
    sheet.hidden = false;
    lockScroll(true);
    openBtn.setAttribute('aria-expanded', 'true');
    void sheet.offsetWidth;            // reflow so the slide runs from the hidden state
    sheet.classList.add('is-open');
    panel.setAttribute('tabindex', '-1');
    panel.focus();
    document.addEventListener('keydown', onKeydown, true);
  }

  function close() {
    if (!sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    lockScroll(false);
    openBtn.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown, true);
    if (reduce.matches) {
      sheet.hidden = true;
    } else {
      if (closeT) clearTimeout(closeT);
      closeT = window.setTimeout(function () { sheet.hidden = true; }, 220);   // the sheet closes in 180ms (custom.css sheet tokens)
    }
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], active = document.activeElement;
    if (!panel.contains(active) || active === panel) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    } else if (e.shiftKey && active === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault(); first.focus();
    }
  }

  openBtn.addEventListener('click', function () {
    if (sheet.classList.contains('is-open')) close(); else open();
  });
  Array.prototype.forEach.call(sheet.querySelectorAll('[data-wb-hd-close]'), function (el) {
    el.addEventListener('click', close);
  });
  // a tap anywhere outside the cream panel closes it (the scrim AND the sheet's own layer)
  sheet.addEventListener('click', function (e) { if (!panel.contains(e.target)) close(); });
  // a link inside the sheet: close as the page leaves, so Back never returns to a locked page
  panel.addEventListener('click', function (e) { if (e.target.closest('a[href]')) close(); });
  // coming back via the back/forward cache: never restore a locked, half-open page
  window.addEventListener('pageshow', function (e) { if (e.persisted && sheet.classList.contains('is-open')) close(); });

  // Growing to desktop while open → close + release scroll (sheet is mobile-only).
  var desktop = window.matchMedia('(min-width: 1200px)');   // = the inline-nav breakpoint in custom.css
  function onBp(e) { if (e.matches) close(); }
  if (desktop.addEventListener) desktop.addEventListener('change', onBp);
  else if (desktop.addListener) desktop.addListener(onBp);
})();

/* Wagbowl — Moisture tiles water-fill + counter (progressive enhancement).
   Server renders the END state (water filled via CSS, number = end), so no-JS AND
   reduced-motion show the final value with no layout shift. With motion + JS: mark the
   section .wb-mt--js (CSS drops the water to 0), reset the number to start, then on
   scroll-in add .is-filled (CSS raises the water) and count start→end. CSS owns the fill
   transition; JS only flips classes + runs the counter. No-ops off-page. */
(function () {
  'use strict';

  var section = document.querySelector('.wb-mt');
  if (!section) return;
  var hero = section.querySelector('.wb-mt__hero');
  if (!hero) return;
  var numEl = hero.querySelector('.wb-mt__num');
  var startV = parseInt(hero.getAttribute('data-start'), 10);
  var endV = parseInt(hero.getAttribute('data-end'), 10);
  if (isNaN(startV)) startV = 10;
  if (isNaN(endV)) endV = 70;

  // Reduced-motion / no IO → leave the server-rendered end state (filled, number = end).
  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) return;

  section.classList.add('wb-mt--js'); // CSS drops the water to 0, ready to rise
  if (numEl) numEl.textContent = startV;

  var raf = null;
  function count(from, to, dur) {
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3); // ease-out cubic, in sync with the ~1.8s water fill
      if (numEl) numEl.textContent = Math.round(from + (to - from) * e);
      if (p < 1) raf = window.requestAnimationFrame(step);
    }
    raf = window.requestAnimationFrame(step);
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();
        hero.classList.add('is-filled'); // CSS raises the water to --wb-mt-fill
        count(startV, endV, 1800);
      });
    },
    { threshold: 0.35 }
  );
  io.observe(hero);
})();

/* Wagbowl — How It Works reveal (progressive enhancement).
   ONE observer drives BOTH breakpoints: reset to start (.wb-hiw--js), then on scroll-in call
   reveal() once (.is-playing). CSS owns the motion — mobile: the green trail grows to the
   step-3 ring; desktop: the dashed connector draws L→R (mask scaleX) and the three wells pop
   in sequence. reveal() also types the accent word out char-by-char (once). The hidden
   breakpoint's elements are display:none, so inert. Reduced-motion / no-JS: default CSS is the
   END state (trail full, dashes drawn, wells visible, full word). transform / opacity / height
   only. No-ops off-page. */
(function () {
  'use strict';

  var steps = document.querySelector('[data-wb-hiw]');
  if (!steps) return;

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) return;

  steps.classList.add('wb-hiw--js'); // reset both rails to their start state

  // Type the "made simple" accent out char-by-char, once (data-typed guards against replay).
  var card = steps.parentNode;
  function typeAccent() {
    var textEl = card && card.querySelector('.wb-hiw__accent-text');
    if (!textEl || textEl.getAttribute('data-typed')) return;
    textEl.setAttribute('data-typed', '1');
    var txt = textEl.textContent;
    textEl.textContent = '';
    for (var c = 0; c < txt.length; c++) {
      var ch = document.createElement('span');
      ch.className = 'wb-hiw__char';
      ch.textContent = txt.charAt(c);
      ch.style.transitionDelay = (c * 45) + 'ms';
      textEl.appendChild(ch);
    }
    void textEl.offsetWidth;   // reflow so the reveal transitions
    textEl.classList.add('is-typed');
  }

  function reveal() {
    steps.classList.add('is-playing'); // mobile trail + desktop dash-draw + well pop
    typeAccent();
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();
        reveal();
      });
    },
    { threshold: 0.3 }
  );
  io.observe(steps);
})();

/* ---- SWIPE DOWN TO CLOSE (25 Oct 2026, Kevan: drawers should "feel as any top app") ----
   One helper for every bottom sheet on a phone: drag its top (grip, header) down and the sheet follows the finger
   while the page behind lightens; let go past a quarter of its height, or flick, and it closes on the normal
   transition; otherwise it springs back. Never starts on a button, link or field (the menu's grip button is allowed:
   the click after a drag is swallowed). Timing + curve stay in custom.css (sheet tokens); .is-dragging pauses them. */
(function () {
  'use strict';
  var phone = window.matchMedia('(max-width: 749px)');
  var SKIP = 'a[href], input, select, textarea, [data-q], .quantity, [data-wb-city-open], .drawer__close, .wb-city__opt';
  function sheetDrag(o) {
    document.addEventListener('pointerdown', function (e) {
      if (!phone.matches || (e.pointerType === 'mouse' && e.button !== 0)) return;
      var z = e.target.closest(o.zone);
      if (!z || !o.isOpen() || e.target.closest(SKIP)) return;
      var panel = o.panel(z); if (!panel) return;
      var scrim = o.scrim ? o.scrim(panel) : null, id = e.pointerId, y0 = e.clientY, dy = 0, moved = false;
      var lastY = y0, lastT = e.timeStamp, vy = 0, h = panel.offsetHeight || 1;
      function move(ev) {
        if (ev.pointerId !== id) return;
        dy = Math.max(0, ev.clientY - y0);
        if (!moved && dy < 6) return;
        if (!moved) { moved = true; panel.classList.add('is-dragging'); if (scrim) scrim.classList.add('is-dragging'); }
        var dt = ev.timeStamp - lastT; if (dt > 0) vy = (ev.clientY - lastY) / dt; lastY = ev.clientY; lastT = ev.timeStamp;
        panel.style.transform = 'translateY(' + dy + 'px)';
        if (scrim) scrim.style.opacity = String((o.scrimMax || 1) * Math.max(0, 1 - dy / h));
        ev.preventDefault();
      }
      function up(ev) {
        if (ev.pointerId !== id) return;
        document.removeEventListener('pointermove', move); document.removeEventListener('pointerup', up); document.removeEventListener('pointercancel', up);
        if (!moved) return;
        panel.classList.remove('is-dragging'); if (scrim) scrim.classList.remove('is-dragging');
        panel.style.transform = ''; if (scrim) scrim.style.opacity = '';   // the CSS transition carries it from here
        if (dy > h * 0.25 || vy > 0.5) o.close();
        var swallow = function (c) { c.stopPropagation(); c.preventDefault(); };   // the click that ends a drag is not a tap
        document.addEventListener('click', swallow, true);
        setTimeout(function () { document.removeEventListener('click', swallow, true); }, 0);
      }
      document.addEventListener('pointermove', move, { passive: false });
      document.addEventListener('pointerup', up); document.addEventListener('pointercancel', up);
    });
  }
  window.WBSheetDrag = sheetDrag;
  // the menu
  sheetDrag({ zone: '.wb-hd-sheet__handle', panel: function (z) { return z.closest('.wb-hd-sheet__panel'); },
    scrim: function (p) { return p.parentNode.querySelector('.wb-hd-sheet__scrim'); },
    isOpen: function () { return !!document.querySelector('.wb-hd-sheet.is-open'); },
    close: function () { var s = document.querySelector('.wb-hd-sheet.is-open .wb-hd-sheet__scrim'); if (s) s.click(); } });
  // the cart (its insides re-render on every change, so everything is looked up at drag time)
  sheetDrag({ zone: 'cart-drawer .drawer__header', panel: function (z) { return z.closest('.drawer__inner'); },
    scrim: function () { return document.getElementById('CartDrawer-Overlay'); }, scrimMax: 0.42,
    isOpen: function () { return !!document.querySelector('cart-drawer.active'); },
    close: function () { var c = document.querySelector('cart-drawer'); if (c && c.close) c.close(); } });
  // the delivery city list (snippets/wb-city)
  sheetDrag({ zone: '.wb-city__grip, .wb-city__h, .wb-city__sub', panel: function (z) { return z.closest('.wb-city__panel'); },
    scrim: function (p) { return p.parentNode.querySelector('.wb-city__scrim'); },
    isOpen: function () { var c = document.getElementById('wb-city'); return !!c && !c.hidden; },
    close: function () { var s = document.querySelector('#wb-city .wb-city__scrim'); if (s) s.click(); } });
})();
